import * as React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../app/context'
import Navigator from '../app/navigator'
import { ProfilerOperation } from '../domain/Operation'
import { ServiceType } from '../domain/Service'
import Link from '../helper/link'
import { allowedDurationsForTracepoints, maxConcurrentTracepoints, planSupportsTracepoints } from '../helper/tracepoints'
import { ApplicationState } from '../redux/ApplicationState'
import { parseTransactionName } from '../ui/transactionName'
import { TransactionPageType } from '../ui/transactionPageType'
import DropdownComponent from './operation/dropdown'
import Tracepoint from './operation/tracepoint'
import AddTracepointForm from './operation/tracepoint-form/add-tracepoint-form'

interface OwnProps {
    transaction: ProfilerOperation
}

interface StateProps {
    tidewaysContext: TidewaysContext
    navigator: Navigator
}

interface State {
    addTracepoint: boolean
    tracepointError: string | null
}

type Props = StateProps & OwnProps

class TransactionNavigation extends React.Component<Props, State> {
    public state: State = {
        addTracepoint: false,
        tracepointError: null,
    }

    public render = () => {
        const transactionName = parseTransactionName(this.props.transaction.identifier)
        const { transaction, tidewaysContext } = this.props

        return (
            <>
                <div className="row">
                    <div className="col-md-8">
                        <div className="tw-pv-8 tw-ph-16">
                            {transactionName.tag && transaction.parentId ? (
                                <>
                                    <Link
                                        route="XhprofProfilerBundle.Transaction.show"
                                        params={{ operation: transaction.parentId }}
                                        className="text-link tw-font-weight-normal"
                                    >
                                        <span className="tw-mr-4">Transaction</span>
                                        <strong>{transactionName.name}</strong>
                                        <TransactionPageType transaction={this.props.transaction} />
                                        {this.props.transaction.name !== this.props.transaction.identifier ? (
                                            <span className="tw-ml-4">({this.props.transaction.name})</span>
                                        ) : null}
                                    </Link>
                                    <span className="tw-mh-8">»</span>
                                    <span>Tagged with: {transactionName.tag}</span>
                                </>
                            ) : (
                                <span className="text-muted">
                                    Transaction <strong>{transactionName.name}</strong>
                                    <TransactionPageType transaction={this.props.transaction} />
                                    {this.props.transaction.name !== this.props.transaction.identifier ? (
                                        <span className="tw-ml-8">({this.props.transaction.name})</span>
                                    ) : null}
                                </span>
                            )}
                        </div>
                    </div>
                    {!this.state.addTracepoint ? (
                        <div className="col-md-4">
                            <div className="pull-right">
                                <div className="dropdown">
                                    <a href="#" className="btn btn-sm btn-default dropdown-toggle" data-toggle="dropdown">
                                        <i className="fa fa-bars"></i>
                                    </a>
                                    <DropdownComponent alignment={'right'}>
                                        <Link
                                            route="XhprofProfilerBundle.Transaction.edit"
                                            params={{ operation: this.props.transaction.id }}
                                        >
                                            Edit Transaction
                                        </Link>
                                        {this.props.tidewaysContext.application.license.automaticTracepointTriggers ? (
                                            <Link
                                                route="XhprofProfilerBundle.AutomaticTracepointTrigger.manageForTransaction"
                                                params={{ operation: this.props.transaction.id }}
                                            >
                                                Tracepoint Trigger
                                            </Link>
                                        ) : null}
                                        {this.props.tidewaysContext.application.license.transactionVisibility &&
                                        this.props.transaction.active ? (
                                            <Link
                                                route="XhprofProfilerBundle.Transaction.deactivate"
                                                params={{ operation: this.props.transaction.id }}
                                                query={{ origin: 'details' }}
                                            >
                                                Change to &quot;Limited&quot; Visibility
                                            </Link>
                                        ) : null}
                                        {!this.props.transaction.active ? (
                                            <Link
                                                route="XhprofProfilerBundle.Transaction.activate"
                                                params={{ operation: this.props.transaction.id }}
                                                query={{ origin: 'details' }}
                                            >
                                                {this.props.tidewaysContext.application.license.transactionVisibility
                                                    ? 'Change to "Full" Visibility'
                                                    : 'Activate Transaction'}
                                            </Link>
                                        ) : null}
                                        {!this.props.transaction.ignored ? (
                                            <Link
                                                route="XhprofProfilerBundle.Transaction.ignore"
                                                params={{ operation: this.props.transaction.id }}
                                                query={{ origin: 'details' }}
                                            >
                                                Ignore Transaction
                                            </Link>
                                        ) : null}
                                    </DropdownComponent>
                                </div>
                            </div>

                            <div className="pull-right" style={{ paddingRight: '5px' }}>
                                {!this.props.transaction.ignored &&
                                    planSupportsTracepoints(tidewaysContext) &&
                                    this.props.transaction.serviceType === ServiceType.php && (
                                        <Tracepoint
                                            maxConcurrent={maxConcurrentTracepoints(tidewaysContext)}
                                            onAdd={errorMessage =>
                                                this.setState({
                                                    addTracepoint: true,
                                                    tracepointError: errorMessage,
                                                })
                                            }
                                            operation={this.props.transaction}
                                            service={tidewaysContext.service}
                                            environment={tidewaysContext.environment}
                                        />
                                    )}
                            </div>
                            <div className="pull-right">
                                <Link className="btn btn-sm btn-default" route="XhprofOrganizationBundle.Application.trigger">
                                    Trigger Trace
                                </Link>
                            </div>
                        </div>
                    ) : null}
                </div>
                {this.state.addTracepoint ? (
                    <AddTracepointForm
                        operation={this.props.transaction}
                        allowedDurations={allowedDurationsForTracepoints(tidewaysContext)}
                        onExit={() => this.setState({ addTracepoint: false })}
                    />
                ) : null}
            </>
        )
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props) => {
    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route),
    }
})(TransactionNavigation)
